export function createViolationResponse(violations) {
  const initObj = {
    status: 400,
    statusText: "400 Bad Request"
  };

  const json = {
    "@context": "/contexts/ConstraintViolation",
    "@type": "ConstraintViolation",
    "hydra:description": "A violation error occured",
    "hydra:title": "A violation error occurred",
    violations
  };

  const error = new Response(JSON.stringify(json), initObj);

  return { error, json };
}
